import { gql } from "@apollo/client"

export default gql`
    query getPrompt($mediaUUID: String!) {
        getPrompt(mediaUUID: $mediaUUID) {
            languages {
                name
            }
            downloadableAudio {
                binaryData
                fileName
            }
        }
    }
`
